var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",[_c('v-chip',{attrs:{"color":_vm.status.color,"dark":"","small":"","outlined":""}},[_vm._v(" "+_vm._s(_vm.status.label)+" ")])],null,{ status: _vm.status })],2)}
var staticRenderFns = []

export { render, staticRenderFns }